import React from "react";
import { useAppDispatch, useAppSelector } from "../../../../../app/hooks";
import { Alert, Avatar, IconButton, Stack, Typography } from "@mui/material";
import { Assignment, Edit, Delete } from "@mui/icons-material";
import { formatDate } from "@progress/kendo-intl";
import {
  toggleIncidentCommentEditModal,
  toggleIncidentCommentDeleteModal,
} from "../../../../../app/slices/VarianceModuleSlice";
import { useMyProfileQuery } from "../../../../../services/profileService/profile-api";

function IncidentCommentList() {
  const dispatch = useAppDispatch();
  const { data: profileData } = useMyProfileQuery();
  const incident = useAppSelector(
    (state) => state.varianceRequest.varianceRequest
  );
  const convertedComments = () => {
    let p = incident?.comments.map((obj) => {
      return { ...obj, addDate: new Date(obj.addDate) };
    });
    return p;
  };
  // Sort the comments in descending order based on the addDate
  const sortedComments = convertedComments()
    .slice()
    .sort((a, b) => b.addDate.getTime() - a.addDate.getTime());

  const canEditComment = (comment: any) => {
    return profileData?.identity === comment.addedBy || profileData?.isAdmin;
  };

  const handleEditComment = (comment: any) => {
    dispatch(toggleIncidentCommentEditModal(comment));
  };

  const handleDeleteComment = (comment: any) => {
    dispatch(toggleIncidentCommentDeleteModal(comment));
  };

  return (
    <React.Fragment>
      {incident?.comments?.length === 0 && (
        <Alert color="warning">This Incident currently has no comments.</Alert>
      )}      {sortedComments.map((i, index) => (
        <div
          key={i.commentId || `comment-${index}-${i.addDate.getTime()}`}
          style={{
            borderBottom: "2px solid #62BCBD",
            marginBottom: "5px",
            paddingBottom: "5px",
          }}
        >
          {" "}
          <Stack direction="row" alignItems="center" gap={2} marginLeft="10px">
            <Avatar style={{ backgroundColor: "#62BCBD" }}>
              <Assignment />
            </Avatar>
            <Typography>
              {i.addedBy +
                " on " +
                formatDate(new Date(i.addDate ?? ""), "MM/dd/yyyy hh:mm")}
            </Typography>
            {canEditComment(i) && (
              <Stack direction="row" marginLeft="auto">
                <IconButton
                  size="small"
                  onClick={() => handleEditComment(i)}
                  sx={{ color: "#1976d2" }}
                >
                  <Edit fontSize="small" />
                </IconButton>
                <IconButton
                  size="small"
                  onClick={() => handleDeleteComment(i)}
                  sx={{ color: "#d32f2f" }}
                >
                  <Delete fontSize="small" />
                </IconButton>
              </Stack>
            )}
          </Stack>
          <Typography marginLeft="70px">{i.text}</Typography>
        </div>
      ))}
    </React.Fragment>
  );
}

export { IncidentCommentList };
